import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const ReloadWrapper = Box.withConfig({
  marginX: 0,
  marginY: '$4',
});

export const InstructionText = withTypography({
  mt: '$3',
  mx: '$0',
  mb: '$0',
  fontSize: 'sm',
  p: '$0',
  bold: true,
  style: { width: '100%' },
});

export const LoadContainer = Box.withConfig({
  marginTop: '$6',
});
